import api from '../api'

export default {

  branches: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/branches?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  create: async branch => {
    return api.post('api/branches', branch)
  },

  get: async id => {
    return api.get('api/branches/' + id)
  },

  update: async (id,branch) => {
    return api.put('api/branches/' + id, branch)
  },

  delete: async id => {
    return api.delete('api/branches/' + id)
  }
}
